import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BrandOptions, CategoryOptions, MeasuringunitOptions, ProductOptions, SubCategoryOptions } from 'app/_models/optionsList/options';
import { PurchaseOrders } from 'app/_models/purchaseOrders/purchase-orders';
import { UserModel } from 'app/_models/user-model';
import { CrudPurchaseOrderDetailsService } from 'app/_services/MasterCrudOps/crud-purchase-order-details.service';
import { OptionslistService } from 'app/_services/optionslist.service';
declare const swal: any;

@Component({
  selector: 'app-add-more-order-details',
  templateUrl: './add-more-order-details.component.html'
})
export class AddMoreOrderDetailsComponent implements OnInit {
   @Output() toggle = new EventEmitter();
  @Output() updatePoList = new EventEmitter();
    addMorePurchaseOrderDetailForm: UntypedFormGroup | null = null;
  pageNumber: number;
  pageSize: number;
  poNumber:string = "";
  purchaseOrderDetail:PurchaseOrders;
brandOptions: BrandOptions[] = [];
  productOptions: ProductOptions[] = [];
  categoryOptions: CategoryOptions[] = [];
  subCategoryOptions: SubCategoryOptions[] = [];
  measuringOptions: MeasuringunitOptions[] = [];
  currentUser: UserModel;
  isAdminGroupUser:boolean = false;
  
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly optionslistService: OptionslistService,
    private readonly purchaseOrderService: CrudPurchaseOrderDetailsService,
    private readonly dialogRef: MatDialogRef<AddMoreOrderDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.purchaseOrderDetail = JSON.parse(JSON.stringify(data.poDetail));
    this.poNumber = this.purchaseOrderDetail.poNumber;
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
     this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }


    ngOnInit(): void {
    this.addMorePurchaseOrderDetailForm = this.formBuilder.group({
      PurchaseOrderDetails: new UntypedFormArray([]),
    });
    this.addItem();
    this.getProducts();
    this.getBrandOptions();
    this.getmeasuringUnits();
  }

  getmeasuringUnits() {
    this.optionslistService.getMeasuringunitOptions().subscribe((data) => {
      this.measuringOptions = data;
    });
  }

  initilizeForm() {
    this.addMorePurchaseOrderDetailForm = this.formBuilder.group({
      PurchaseOrderDetails: new UntypedFormArray([]),
    });
  }

  addItem(): void {
    let formGroup = new UntypedFormGroup({
      productId: new UntypedFormControl(null, [Validators.required]),
      categoryId: new UntypedFormControl(null, [Validators.required]),
      subcategoryId: new UntypedFormControl(null, [Validators.required]),
      brandId: new UntypedFormControl(null, [Validators.required]),
      orderQuantity: new UntypedFormControl(null, [Validators.required]),
      warrantyInMonths: new UntypedFormControl(null, [Validators.required]),
      measuringUnitId: new UntypedFormControl(null, [Validators.required]),
      unitPrice: new UntypedFormControl(null, [Validators.required]),
    });

    (<UntypedFormArray>(
      this.addMorePurchaseOrderDetailForm.get("PurchaseOrderDetails")
    )).push(formGroup);
  }

  onRemoveItem(index: number) {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Remove IT!",
    }).then((result) => {
      if (result === true) {
        (<UntypedFormArray>(
          this.addMorePurchaseOrderDetailForm.get("purchaseOrderDetail")
        )).removeAt(index);
      }
    });
  }

  getBrandOptions() {
    this.optionslistService.getBrandOptions().subscribe((data) => {
      this.brandOptions = data;
    });
  }

  saveMorePurchaseOrderDetails() {
    swal({
      title: "Are you sure?",
      text: "More purchase order details will be saved",
      type: "warning",
      showCancelButton: true,
      cancelButtonClass: "btn btn-danger",
      confirmButtonClass: "btn btn-success",
      confirmButtonText: "Save",
    }).then((result) => {
      if (result) {
        let model = {
          findiPurchaseOrderId: this.purchaseOrderDetail.findiPurchaseOrderId,
          purchaseOrderDetails:
            this.addMorePurchaseOrderDetailForm.value.PurchaseOrderDetails,
        };
        this.purchaseOrderService.addMorePurchaseOrderDetails(model).subscribe(
          (response) => 
            {
            this.addMorePurchaseOrderDetailForm.reset();
            this.toggle.emit({ args: true });
            this.updatePoList.emit({ args: true });
            if (response.didError) {
              swal({
                title: "",
                text: response.message,
                type: "error",
                confirmButtonClass: "btn btn-info",
              });
            } else {
              swal({
                title: "",
                text: response.message,
                type: "success",
                confirmButtonClass: "btn btn-info",
              });
            }
            let result = {
              status: true,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize,
            };
            this.dialogRef.close(result);
          },
          (error) => {
            let errorMessage =
              error.error?.title ??
              error.error ??
              "Something went wrong. Please contact admin.";

            // Check if it's a validation error response with the `errors` object
            if (error.error?.errors) {
              const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
              if (allErrors.length > 0) {
                errorMessage = allErrors[0]; // Use the first validation message
              }
            } else if (typeof error.error === "string") {
              errorMessage = error.error;
            } else if (error.error?.title) {
              errorMessage = error.error.title;
            }
            swal({
              title: "",
              text: errorMessage,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        );
      }
    });
  }

  getProducts() {
    this.optionslistService.getProductsOptions().subscribe((data) => {
      this.productOptions = data;
    });
  }

  onProductSelectionchange(e) {
    this.optionslistService
      .getCategoryByProductOptions(e.value)
      .subscribe((categories) => {
        this.categoryOptions = categories;
      });
  }

  onCategorySelectionchange(e) {
    this.optionslistService
      .getSubCategoryByCategoryOptions(e.value)
      .subscribe((subcats) => {
        this.subCategoryOptions = subcats;
      });
  }

  goBackClick() {
    this.dialogRef.close(false);
  }

}
